import React from "react";
import CategoryPage from "./CategoryPage";

function TribalVoices({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Tribal Voices"
      parentCategory="Articles"
      posts={posts}
      publications={publications}
    />
  );

}

export default TribalVoices;